import { combineReducers } from "redux";

import basicRequest from "../../../core/redux/reducers/request";

import session from "./session";
import locale from "./locale";
import migracion from "./migracion";
import information from "./information";
import box from "./box";

const brand = basicRequest("BRAND");
const theme = basicRequest("THEME");

export default combineReducers({
    session,
    locale,
    migracion,
    information,
    box,
    brand,
    theme,
});
